/* istanbul ignore file */
import { useFieldHelper, TextField, FieldProps } from 'framework/ui/field';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT, getWithThousandsSeparator } from 'framework/utils';
import { useSensitiveDataContext } from 'framework/sensitiveData';

const DavinciTransfersField = ({
  isSensitiveDataIsShown,
  ...props
}: FieldProps & { isSensitiveDataIsShown?: boolean }) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const transfers = getValue() as any;
  const sensitiveDataContext = useSensitiveDataContext();

  const displayedContacts = transfers?.map((transfer: Dictionary<any>) => {
    const { id, description, asDateOf } = transfer;
    const amount = sensitiveDataContext.getValueByIdAndSource('davinciTransfersSubTotal', id) || 0;

    return (
      <div key={id}>
        {asDateOf ? (
          <>
            <ShowDate dateUTC={asDateOf} format={DATE_FORMAT.SIMPLE} isDateTime={false} />
            {isSensitiveDataIsShown ? ', ' : ' - '}
          </>
        ) : null}
        {isSensitiveDataIsShown ? `${getWithThousandsSeparator(amount)}$ - ` : null}
        {description}
      </div>
    );
  });

  return <TextField value={displayedContacts} label={getLabel()} isColumnDirection={transfers?.length > 1} />;
};

export default DavinciTransfersField;
